var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { attr, decorate, listen, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { debounce } from '@exadel/esl/modules/esl-utils/async/debounce';
import { UIPPlugin } from '../../core/base/plugin';
import { UIPSnippets } from '../snippets/snippets';
import './snippets-list.shape';
/**
 * Snippets List {@link UIPPlugin} custom element definition
 * Container class for snippets (component's templates)
 */
export class UIPSnippetsList extends UIPPlugin {
    get $root() {
        const parent = this.closest(`${UIPSnippets.is}`);
        if (parent)
            return parent.$root;
        return super.$root;
    }
    /** {@link UIPPlugin} section wrapper */
    get $inner() {
        const pluginType = this.constructor;
        return React.createElement("ul", { className: `${pluginType.is}-inner esl-scrollable-content` }, this.$items);
    }
    /** Snippets list from dropdown element*/
    get $items() {
        if (!this.model)
            return [];
        return this.model.snippets.map(this.buildListItem.bind(this)).filter((item) => !!item);
    }
    connectedCallback() {
        super.connectedCallback();
        this.appendChild(this.$inner);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.innerHTML = '';
        memoize.clear(this, ['$items', '$inner']);
    }
    /** Initializes snippets layout */
    rerender() {
        this.$inner.innerHTML = '';
        memoize.clear(this, '$items');
        this.$inner.append(...this.$items);
    }
    /** Builds snippets list item */
    buildListItem(snippet, index) {
        if (!snippet.label)
            return;
        const classes = [this.itemCls];
        if (snippet.active)
            classes.push(this.activeCls);
        if (snippet.isolated)
            classes.push(this.isolatedCls);
        return React.createElement("li", { className: classes.join(' ') },
            React.createElement("button", { type: "button", className: this.itemBtnCls, "uip-snippet-index": index }, snippet.label));
    }
    /** Handles `click` event to manage active snippet */
    _onItemClick(e) {
        var _a;
        const { snippets } = this.model;
        const index = ((_a = e.$delegate) === null || _a === void 0 ? void 0 : _a.getAttribute('uip-snippet-index')) || '';
        if (!index || !snippets)
            return;
        this.model.applySnippet(snippets[+index], this);
        e.preventDefault();
    }
    /** Handles `uip:snippet:change` event to rerender snippets list */
    _onRootStateChange() {
        this.rerender();
    }
}
UIPSnippetsList.is = 'uip-snippets-list';
__decorate([
    attr({ defaultValue: 'uip-snippets-item-wrapper' })
], UIPSnippetsList.prototype, "itemCls", void 0);
__decorate([
    attr({ defaultValue: 'uip-snippets-item' })
], UIPSnippetsList.prototype, "itemBtnCls", void 0);
__decorate([
    attr({ defaultValue: 'uip-snippets-item-active' })
], UIPSnippetsList.prototype, "activeCls", void 0);
__decorate([
    attr({ defaultValue: 'uip-snippets-item-isolated' })
], UIPSnippetsList.prototype, "isolatedCls", void 0);
__decorate([
    memoize()
], UIPSnippetsList.prototype, "$root", null);
__decorate([
    memoize()
], UIPSnippetsList.prototype, "$inner", null);
__decorate([
    memoize()
], UIPSnippetsList.prototype, "$items", null);
__decorate([
    decorate(debounce, 0)
], UIPSnippetsList.prototype, "rerender", null);
__decorate([
    listen({ event: 'click', selector: '[uip-snippet-index]' })
], UIPSnippetsList.prototype, "_onItemClick", null);
__decorate([
    listen({ event: 'uip:snippet:change', target: ($this) => $this.$root })
], UIPSnippetsList.prototype, "_onRootStateChange", null);
